var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconMedicalSuitcase(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 4C7.89543 4 7 4.89543 7 6V7H4C2.89543 7 2 7.89543 2 9V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V9C22 7.89543 21.1046 7 20 7H17V6C17 4.89543 16.1046 4 15 4H9ZM15 7V6H9V7H15ZM8 9H16H20V18H4V9H8ZM10.875 12.625C11.0131 12.625 11.125 12.5131 11.125 12.375V10.25C11.125 10.1119 11.2369 10 11.375 10H12.625C12.7631 10 12.875 10.1119 12.875 10.25V12.375C12.875 12.5131 12.9869 12.625 13.125 12.625H15.25C15.3881 12.625 15.5 12.7369 15.5 12.875V14.125C15.5 14.2631 15.3881 14.375 15.25 14.375H13.125C12.9869 14.375 12.875 14.4869 12.875 14.625V16.75C12.875 16.8881 12.7631 17 12.625 17H11.375C11.2369 17 11.125 16.8881 11.125 16.75V14.625C11.125 14.4869 11.0131 14.375 10.875 14.375H8.75C8.61193 14.375 8.5 14.2631 8.5 14.125V12.875C8.5 12.7369 8.61193 12.625 8.75 12.625H10.875Z", fill: color })));
}
//# sourceMappingURL=icon.medical-suitcase.component.js.map